// extracted by mini-css-extract-plugin
export default {"tag-edit":"TagEdit_tag-edit__vDuqq","tag-edit__type":"TagEdit_tag-edit__type__kEGrE","tag-edit__type-hint":"TagEdit_tag-edit__type-hint__TxInX"};